import { render, staticRenderFns } from "./third-party-search.vue?vue&type=template&id=edb83db0"
import script from "./third-party-search.vue?vue&type=script&lang=js"
export * from "./third-party-search.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports